<template>
	<section
		class="video_or_image"
		:class="{'modal-open': theModalStatus === true}"
		:style="cssVars"
	>
		<div class="container">
			<div class="video_or_image__inner">
				<div
					class="video_or_image__inner__video"
					v-if="video_source && video_poster && choice === 'video'"
				>
					<video-modal
						@isModalOpen="getModalData"
						:has_border="'no'"
						:video_poster="video_poster"
						:video_source="video_source"
					></video-modal>
				</div>
				<div
					class="video_or_image__inner__image"
					v-else
				>
					<img
						v-if="image"
						:src="image"
						alt="image"
					/>

				</div>
			</div>
			<caption
				v-if="caption"
				v-html='caption'
			></caption>
		</div>
	</section>
</template>

<script>
import VideoModal from './VideoModal.vue';

export default {
	data() {
		return {
			theModalStatus: false,
		};
	},

	props: {
		choice: {},
		image: {},
		video_poster: {},
		video_source: {},
		size: {},
		caption: {},
	},

	computed: {
		cssVars() {
			return {
				'--size': this.size ? this.size : 'span 12',
			};
		},
	},

	watch: {},

	methods: {
		getModalData(arg) {
			this.theModalStatus = arg;
			return arg;
		},
	},

	components: {
		VideoModal,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.video_or_image {
	transition: 0.2s ease all;

	.mixed_content & {
		grid-column: var(--size);
		/* border: 2px solid transparent; */
	}

	.container {
		// @media (max-width: $mobile-xl) {
		// 	padding: 0;
		// 	margin: 0;
		// 	max-width: 100%;
		// }
	}

	&.modal-open {
		// z-index: 999;
		pointer-events: none;
		position: relative;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	caption {
		display: flex;
		flex-wrap: wrap;
		grid-column: 3 / span 8;
		border-bottom: 1px solid black;
		padding: 12px 0;
		font-size: 12px;
		line-height: 18px;
		text-align: left;
	}

	&__inner {
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		gap: var(--gutter-tablet-desktop);
		grid-column: span 12;

		@media (max-width: $mobile-xl) {
			grid-column: span 12;
			margin-right: 0;
		}

		/* .single & {
			grid-column: 3 / span 8;
		}

		.anchored & {
			grid-column: 1 / span 12;
		}

		.single-project & {
			grid-column: 1 / span 12;

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
			}
		} */

		&__video {
			grid-column: var(--size);
			/* border: var(--border); */
			// background: #ededed 0% 0% no-repeat padding-box;
			opacity: 1;

			.mixed_content & {
				grid-column: span 12;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 12;
				margin-right: 0;
			}
		}

		&__image {
			grid-column: var(--size);
			/* border: var(--border); */
			// background: #ededed 0% 0% no-repeat padding-box;
			aspect-ratio: 16 / 9;
			opacity: 1;

			.mixed_content & {
				grid-column: span 12;

				@media (max-width: 1440px) {
					aspect-ratio: unset;
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 12;
				margin-right: 0;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				display: flex;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/VideoImage.vue